export default __webpack_public_path__ + "static/media/zero_fraise.8e2bb6f1.png";